module.exports = __webpack_public_path__ + "media/images/payson-0b81a51823024869681f431a4fa8ad51.gif";